import router from "@/router";

export const analyzeRoutePath = (routeName: string) => {
  if (routeName) {
    if ("Template".indexOf(routeName) >= 0) {
      return "1";
    } else if ("Custom".indexOf(routeName) >= 0) {
      return "2";
    } else if ("Fragment".indexOf(routeName) >= 0) {
      return "3";
    } else if ("Destroy".indexOf(routeName) >= 0) {
      return "4";
    }
  }
  return "0";
};

export const toRouteByCode = (code: string) => {
  console.log("code", code);
  switch (code) {
    case "1":
      console.log("/template");
      return router.push("/template");
    case "2":
      console.log("/custom");
      return router.push("/custom");
    case "3":
      console.log("/fragment");
      return router.push("/fragment");
    case "4":
      console.log("/destroy");
      return router.push("/destroy");
    default:
      return;
  }
};
